<template>
  <div class="WorkOrderList">
    <XTable
        :api="getAssistWorkOrder"
        :state="workOrderList"
        :columns="columns"
        :loading="workOrderListLoading"
        :tableSize="tableSize"
        :layout="layout"
        :maxHeight="maxHeight"
        :firstColumn="firstColumn"
    ></XTable>
    <WorkOrderDetailModal :row="row"></WorkOrderDetailModal>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import WorkOrderDetailModal from "@/pages/WorkOrderManagement/WorkOrderDetailModal.vue";
import DateUtil from "@/utils/formatDate";

export default {
  name: "WorkOrderList",
  components: {WorkOrderDetailModal, XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      firstColumn: true,
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      previewList: [],
      row: {}
    };
  },
  computed: {
    ...mapState("fuzhu", ["workOrderList", "workOrderListLoading"]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const typeMap = {
        0: "图片",
        1: "压缩包",
      };
      const columns = [
        {
          prop: "username",
          label: "用户名",
        },
        {
          prop: "email",
          label: "邮箱",
        },
        {
          label: "处理状态",
          render(h, scope) {
            return (
                <div>{(scope.row && scope.row.handled) ? "已处理" : "未处理"}</div>
            );
          },
        },
        {
          label: "工单类型",
          render(h, scope) {
            return (
                <div>{scope.row ? typeMap[scope.row.type] : ""}</div>
            );
          },
        },
        {
          label: "创建时间时间",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.createTime)}</span>
                </div>
            );
          },
        },
      ];
      let workManager = this.permissionCode.has('assist:work:manager');
      let workList = this.permissionCode.has('assist:work:list');
      if (workManager || workList) {
        columns.push({
          label: "操作",
          fixed: "right",
          width: 300,
          render(h, scope) {
            return (
                <div>
                  {(workManager && !scope.row.handled) &&
                      <el-button
                          onClick={() => {
                            self.handleAssistWorkOrder(scope.row.id);
                            self.$message.success("处理成功")
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >标记处理</el-button>
                  }
                  {<el-button
                      onClick={() => {
                        self.handleView(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >查看</el-button>
                  }
                </div>
            );
          },
        })
      }
      return columns;
    },
  },
  methods: {
    ...mapActions("fuzhu", ["getAssistWorkOrder", "handleAssistWorkOrder"]),
    ...mapMutations("fuzhu", ["setData"]),
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
    handleView(row) {
      this.row = row;
      this.setData({
        key: "workOrderListModalVisible",
        value: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.WorkOrderList {
  ::v-deep .box {
  }

  ::v-deep img {
  }
}
</style>
